import useFormInstance from "antd/es/form/hooks/useFormInstance";
import {
    Card,
    Space,
    Divider as AntDivider,
    Row,
    Col,
    Form,
    Input,
    InputNumber,
    Checkbox,
    Switch,
    Table,
    Select as AntSelect,
    Button, FormInstance, message, Popconfirm
} from "antd";
import styles from "./DetailTab.module.css";
import Divider from "../../../components/Divider";
import DatePicker from "../../../components/DatePicker";
import dayjs from "dayjs";
import Select from "../../../components/Select";
import DictSelect from "../../../components/DictSelect";
import {ColumnProps} from "antd/lib/table";
import {useWatch} from "antd/lib/form/Form";
import React, {ComponentProps, Fragment, ReactComponentElement, useEffect, useState} from "react";
import * as productApi from "../../../apis/platforms/dealer/product";
import * as api from '../../../apis/salesOrder'
import * as sampleApi from "../../../apis/sample";
import * as contractApi from "../../../apis/platforms/admin/contract";
import {
    PaymentStatusMapping,
    PlatformType,
    SalesOrderStatusMapping,
    SalesOrderStatusEnum, SalesOrderSourceOptions, LogType
} from "../../../utils/constants";
import {useSelector} from "react-redux";
import {RootState} from "../../../models";
import {useHistory} from "react-router-dom";
import ProductSelectModal from "../../../components/ProductSelectModal";
import AreaSelect from "../../../components/AreaSelect";
import {useRequest} from "ahooks";
import BaseDataSelect from "../../../components/BaseDataSelect";
import DealerShippingSelectModal from "../../../components/DealerShippingSelectModal";
import SendOAPeriodModal from "./SendOAPeriodModal";
import useFormModal from "../../../utils/useFormModal";
import withAuth from "../../../utils/withAuth";
import LogModal from "../../../components/LogModal";
import RemarkModal from "./RemarkModal";
import ContractSelectModal from "../../../components/ContractSelectModal";
import useAuth from "../../../utils/useAuth";

type DetailTabProps = ComponentProps<any> & {
    form: FormInstance
    record: any
    enableEdit: boolean
    setEnableEdit: Function
    doSubmit: Function
    handleBusinessConfirm: Function
    handleModifyShippingCost: Function
    handleModifyGiveaway: Function
    handleSampleAdd?: Function
}

const EditButton = withAuth('edit', Button);
const BusinessConfirmButton = withAuth('businessConfirm', Button);
const ModifyShippingCostButton = withAuth('modifyShippingCost', Button);
const SubmitButton = withAuth('submit', Button);
const AdminSubmitButton = withAuth('adminSubmit', Button);
const ErpSyncFragment = withAuth('erpSync', Fragment);
const ModifyGiveawayButton = withAuth('modifyGiveaway', Button);
const ClosePopconfirm = withAuth('close', Popconfirm);
const PrintButton = withAuth('print', Button);
const CopyButton = withAuth('copy', Button);
const CopyFullButton = withAuth('copy', Button);
const RemarkButton = withAuth('remark', Button);
const CompletePopconfirm = withAuth('complete', Popconfirm);
const OverDueButton = withAuth('overdue', Button);
const DeletePopupconfirm = withAuth('delete', Popconfirm);
const AddSampleButton = withAuth('sample', Button);
const OAFragment = withAuth('oa', Fragment);
const OACompletePopconfirm = withAuth('oaComplete', Popconfirm);
const UpdateContractButton = withAuth('updateContract', Button);
const TemporaryPeriodCol = withAuth('fieldTemporaryPeriodView', Col);


function DetailTab(props: DetailTabProps) {
    const history = useHistory();
    const record = props.record;
    const form = props.form;
    const {enableEdit, setEnableEdit} = props;
    const products: Array<any> = useWatch('item', form) ?? [];
    const province = useWatch('province', form);
    const city = useWatch('city', form);
    const id = record.id;
    const platform = useSelector<RootState, RootState['auth']>(state => state.auth)?.user?.platform ?? PlatformType.Dealer;
    const [productSelectedModalVisible, setProductSelectedModalVisible] = useState(false);
    const [dealerShippingModalVisible, setDealerShippingModalVisible] = useState(false);
    const [remarkModalVisible, setRemarkModalVisible] = useState(false);
    const [contractSelectModalVisible, setContractSelectModalVisible] = useState(false);

    const showPrice = useAuth().indexOf('showPrice') > -1 || platform === PlatformType.Admin;

    useEffect(() => {
        if (!enableEdit) {
            form.setFieldsValue(record);
        }
        props?.onEditableChange?.(enableEdit);
    }, [enableEdit]);

    const {modalProps: sendOAModalProps, setVisible: sendOAModalVisible} = useFormModal({
        onRequest: api.oaSend,
        onOk: () => {
            sendOAModalVisible(false)
            message.success('OA送审成功')
        }
    })

    const {loading: loadingDelete, run: runDelete} = useRequest(api.deleteOrder, {
        manual: true,
        onSuccess(res) {
            message.success('已删除订单');
            history.replace('/order/sales');
        }
    });

    const {loading: loadingOverDue, run: runOverDue} = useRequest(api.overDueOrder, {
        manual: true,
        onSuccess(res) {
            message.success('操作成功');
            window.location.reload();
        }
    })

    const {loading: oASendLoading, run: doOASend} = useRequest(api.oaSend, {
        manual: true,
        onSuccess: () => {
            message.success('OA送审成功')
        }
    })

    const {loading: oACompleteLoading, run: doOAComplete} = useRequest(api.oaComplete, {
        manual: true,
        onSuccess: () => {
            message.success('终审通过成功')
            window.location.reload();
        }
    })

    const {loading: erpSyncLoading, run: doErpSync} = useRequest(api.erpSync, {
        manual: true,
        onSuccess: () => {
            message.success('同步成功')
        }
    })


    const {loading: loadingClose, run: runCloseOrder} = useRequest(api.closeOrder, {
        manual: true,
        onSuccess() {
            window.location.reload();
        }
    })

    const {loading: loadingCopy, run: runCopy} = useRequest(api.copyOrder, {
        manual: true,
        onSuccess(res) {
            message.success('已复制订单，展示新订单');
            window.open(`/order/sales/detail/${res.data.data}`);
        }
    })

    const {loading: loadingCopyFull, run: runCopyFull} = useRequest(api.copyOrderFull, {
        manual: true,
        onSuccess(res) {
            message.success('已复制订单，展示新订单');
            window.open(`/order/sales/detail/${res.data.data}`);
        }
    })

    const {loading: loadingRemark, run: runRemark} = useRequest(api.saveSalesOrderRemark, {
        manual: true,
        onSuccess(res) {
            message.success('修改备注成功');
            setRemarkModalVisible(false);
        }
    })

    const {loading: loadingComplete, run: runComplete} = useRequest(api.completeSalesOrder, {
        manual: true,
        onSuccess(res) {
            window.location.reload();
        }
    })

    const {loading: loadingAdminSubmit, run: runAdminSubmit} = useRequest(api.adminSubmitSalesOrder, {
        manual: true,
        onSuccess(res) {
            message.success('提交成功');
            window.location.reload();
        }
    })

    const {loading: loadingUpdateContract, run: runUpdateContract} = useRequest(api.updateContract, {
        manual: true,
        onSuccess(res) {
            message.success('更新成功');
            setContractSelectModalVisible(false);
            window.location.reload();
        }
    })


    const productColumns: Array<ColumnProps<any>> = [
        {
            dataIndex: 'lineNumber',
            key: 'lineNumber',
            width: enableEdit ? 200 : 100,
            fixed: 'left',
            title: '行号',
            render(v: any, record: any, index) {
                return enableEdit ?
                    <Space><Button disabled={false} onClick={() => handleRemoveProduct(index)}>-</Button><Button
                        disabled={false} onClick={handleAddProduct}>+</Button></Space> : v;
            }
        },
        {
            dataIndex: 'productCode',
            key: 'productCode',
            width: 140,
            title: '商品编码',
            fixed: "left"
        },
        {
            dataIndex: 'productName',
            key: 'productName',
            width: 200,
            title: '商品名称',
        },
        {
            dataIndex: 'specification',
            key: 'specification',
            width: 100,
            title: '商品规格'
        },
        {
            dataIndex: 'categoryName',
            key: 'categoryName',
            width: 200,
            title: '产品线'
        },
        {
            dataIndex: 'method',
            key: 'method',
            title: '方法',
            width: 100,
        },
        {
            dataIndex: 'useIn',
            key: 'useIn',
            title: '适用机型',
            width: 100,
        },
        {
            dataIndex: 'unit',
            key: 'unit',
            width: 100,
            title: '单位'
        },
        // {
        //     dataIndex: 'suitProductQty',
        //     title: '套餐数量',
        //     render(_, record: any) {
        //         return record.suitId && record.suitProductQty;
        //     }
        // },
        {
            dataIndex: 'qty',
            key: 'qty',
            width: 140,
            title: '数量',
            render(v: number, record: any, index) {

                if (!record.productId) {
                    return null;
                }
                if (!enableEdit) {
                    return v;
                }
                return record.suitId ? (
                    <Form.Item name={[index, 'suitQty']}>
                        <InputNumber style={{width: '100%'}} disabled={record.enableGiveaway || !enableEdit} step={1}
                                     min={1} addonBefore={`${record.suitProductQty}*`}
                                     onChange={(v) => handleSuitQtyChange(v, index)}/>
                    </Form.Item>
                ) : (
                    <Form.Item name={[index, 'qty']}>
                        <InputNumber style={{width: '100%'}} disabled={record.enableGiveaway || !enableEdit} step={1}
                                     min={1}/>
                    </Form.Item>
                )
            }
        },
        ...showPrice ? [{
            dataIndex: 'price',
            key: 'price',
            width: 140,
            title: '销售价'
        },
            {
                dataIndex: 'amount',
                key: 'amount',
                width: 100,
                title: '小计'
            },
            {
                dataIndex: 'rebateLimit',
                key: 'rebateLimit',
                width: 100,
                title: '使用返利额度'
            },
            {
                dataIndex: 'rebateType',
                key: 'rebateType',
                width: 100,
                title: '返利类型'
            }
        ] : [],
        {
            dataIndex: 'sampleLimit',
            key: 'sampleLimit',
            width: 100,
            title: '使用样品额度'
        },
        {
            dataIndex: 'expirationDate',
            key: 'expirationDate',
            width: 100,
            title: '效期（月）'
        },
        {
            dataIndex: 'expectedDate',
            key: 'expectedDate',
            width: 200,
            title: '期望交期',
            render(v) {
                return v && dayjs(v)?.format('ll')
            }
        },
        {
            dataIndex: 'enableGiveaway',
            key: 'enableGiveaway',
            width: 80,
            title: '赠品',
            render(v) {
                return !!v ? '是' : '否'
            }
        },
        {
            dataIndex: 'giveawayByContract',
            key: 'giveawayByContract',
            width: 120,
            title: '合同内赠送',
            render(v) {
                return !!v ? '是' : '否'
            }
        },
        {
            dataIndex: 'enableSample',
            key: 'enableSample',
            width: 80,
            title: '样品',
            render(v) {
                return !!v ? '是' : '否'
            }
        },
        {
            dataIndex: 'suitCode',
            key: 'suitCode',
            width: 200,
            title: '套餐编号'
        },
        {
            dataIndex: 'suitName',
            key: 'suitName',
            width: 200,
            title: '套餐名称'
        }
    ];

    const handleAddProduct = () => {
        setProductSelectedModalVisible(true);
    }

    const handleSuitQtyChange = (v: any, index: number) => {
        // (v:number|null)=>Number.isInteger(v)&& form.set('item',index,'qty', (v!!)*record.suitQty)
        const curProduct = products[index];
        const suitId = curProduct.suitId;
        [...products || []].filter(p => p.suitId == suitId).forEach((p: any, i) => {
            form.setFieldValue(['item', i, 'suitQty'], v || 0);
            form.setFieldValue(['item', i, 'qty'], p.suitProductQty * (v || 0));
        });
    }

    const doSelectAddress = (keys: Array<any>, records: Array<any>) => {
        if (!records.length) {
            return;
        }
        const address = records[0];
        form.setFieldValue('receiver', address.name);
        form.setFieldValue('receiverPhone', address.phone);
        form.setFieldValue('province', address.provinceId);
        form.setFieldValue('city', address.cityId);
        form.setFieldValue('detailAddress', address.address);
        setDealerShippingModalVisible(false);
    }

    const handleContractSelected = (keys?: Array<number>, records?: Array<any>) => {
        if (!keys?.length) {
            message.error('请选择合同进行操作');
            return;
        }
        const contractId = keys[0];
        runUpdateContract(id, contractId);

    }
    const doAddProduct = (keys?: Array<number>, records?: Array<any>) => {
        const existProduct = [...records || []].find((p: any) => products?.find((pp: any) => pp.productId == p.productId && !pp.enableGiveaway));
        if (!!existProduct) {
            message.error('选择的商品已存在，请重新选择');
        } else {
            const selectedProducts = [...records || []].map((p: any) => ({
                ...p,
                id: undefined,
                lineNumber: undefined,
                productCode: p.code,
                productName: p.name,
                productQuote: p.quote,
                categoryName: form.getFieldValue('categoryName'),
                qty: 0,
                amount: 0,
                rebateLimit: 0,
                sampleLimit: 0,
                enableGiveaway: false,
                enableSample: false,
                expirationDate: p.expiration
            }));
            form.setFieldValue('item', [...products, ...selectedProducts]);
        }
        setProductSelectedModalVisible(false);
    }


    const handleRemoveProduct = (index: number) => {
        if (products[index]?.enableGiveaway) {
            message.error('赠品不可删除');
            return;
        }
        const product = products[index];
        if (!!product.suitId) {
            form.setFieldValue("item", products.filter((p: any, i) => p.suitId != product.suitId));
        } else {
            form.setFieldValue('item', products.filter((p: any, i: number) => i !== index));
        }
    }

    const finishRemark = (remark: string) => {
        form.setFieldValue('remark', remark);
        runRemark(form.getFieldsValue());
    }

    const renderSummaryAmount = () => {
        return form.getFieldValue('productTotalAmount') || 0.00
    }
    const renderExpectShippingCost = () => {
        return form.getFieldValue('expectShippingCost') || 0.00;
    }
    const renderShippingCost = () => {
        return form.getFieldValue('shippingCost') || 0.00;
    }
    const renderAmount = () => {
        // const express = renderShippingCost() ? renderShippingCost() : renderExpectShippingCost();
        const productAmount = renderSummaryAmount();
        return renderShippingCost() + productAmount;
    }

    return <div className={styles.DetailTabContainer}>
        <div className={styles.Header}>
            <Space size={"large"} className={styles.StatusBar}>
                <span>合同号： {form.getFieldValue('contractCode')}</span>
                <span>产品线：{form.getFieldValue('categoryName')}</span>
                <span>状态：{SalesOrderStatusMapping[form.getFieldValue('status')]}</span>
                <span>支付状态：{PaymentStatusMapping[form.getFieldValue('paymentStatus')]}</span>
                <span>审核编号：{form.getFieldValue('flowId') == null ? '当前不在审核' :
                    <span style={{color: "red", fontWeight: "bold"}}>{form.getFieldValue('flowId')}</span>}</span>
            </Space>
            <Space className={styles.Toolbar}>
                <Divider>
                    {platform === PlatformType.Dealer && !enableEdit && props.handleSampleAdd && record.status == SalesOrderStatusEnum.NOT_SUBMITTED &&
                        <AddSampleButton type={"link"} onClick={props.handleSampleAdd}>添加样品</AddSampleButton>}
                    {platform === PlatformType.Admin && !enableEdit && (record.status == SalesOrderStatusEnum.BUSINESS_PENDING || record.status == SalesOrderStatusEnum.PAYMENT_PENDING || record.status == SalesOrderStatusEnum.OVERDUE_PENDING) &&
                        <RemarkButton type={"link"} loading={loadingRemark}
                                      onClick={() => setRemarkModalVisible(true)}>备注</RemarkButton>}
                    {platform === PlatformType.Dealer && record.status == SalesOrderStatusEnum.DELIVERED &&
                        <CompletePopconfirm title={'是否确认收货'} onConfirm={() => runComplete({id: record.id})}>
                            <Button type={'link'} loading={loadingComplete}>确认收货</Button>
                        </CompletePopconfirm>}
                    {platform === PlatformType.Admin && !enableEdit && record.status == SalesOrderStatusEnum.BUSINESS_PENDING &&
                        <BusinessConfirmButton type={'link'}
                                               onClick={props.handleBusinessConfirm}>商务确认</BusinessConfirmButton>}
                    {platform === PlatformType.Admin && !enableEdit && (record.status == SalesOrderStatusEnum.BUSINESS_PENDING || record.status == SalesOrderStatusEnum.OVERDUE_PENDING) &&
                        <ModifyShippingCostButton type={'link'}
                                                  onClick={props.handleModifyShippingCost}>修改运费</ModifyShippingCostButton>}

                    {platform === PlatformType.Admin && !enableEdit && record.status == SalesOrderStatusEnum.BUSINESS_PENDING &&
                        <ModifyGiveawayButton type={"link"}
                                              onClick={props.handleModifyGiveaway}>修改赠品</ModifyGiveawayButton>}
                    {platform === PlatformType.Dealer && !enableEdit && record.status == SalesOrderStatusEnum.NOT_SUBMITTED &&
                        <SubmitButton type={'link'} onClick={() => props.doSubmit(id)}>提交</SubmitButton>}
                    {platform === PlatformType.Admin && !enableEdit && record.scope == 1 && record.status == SalesOrderStatusEnum.NOT_SUBMITTED &&
                        <AdminSubmitButton type={'link'} onClick={() => runAdminSubmit(id)}>提交</AdminSubmitButton>}
                    {platform === PlatformType.Admin && !enableEdit && record.scope == 1 && record.status == SalesOrderStatusEnum.NOT_SUBMITTED &&
                        <UpdateContractButton type={'link'} onClick={() => setContractSelectModalVisible(true)}
                                              loading={loadingUpdateContract}>更新合同</UpdateContractButton>}
                    {(platform === PlatformType.Dealer || (platform === PlatformType.Admin && record.scope == 1)) && !enableEdit && form.getFieldValue("status") == SalesOrderStatusEnum.NOT_SUBMITTED &&
                        <EditButton type={'link'} onClick={() => setEnableEdit(true)}>修改</EditButton>}
                    {platform === PlatformType.Dealer && !enableEdit && record.status == SalesOrderStatusEnum.NOT_SUBMITTED &&
                        <DeletePopupconfirm title={'是否确认删除？'} onConfirm={() => runDelete(id)}><Button
                            type={'link'} loading={loadingDelete}>删除</Button></DeletePopupconfirm>}
                    {!enableEdit && platform === PlatformType.Dealer && <CopyButton type={'link'} loading={loadingCopy}
                                                                                    onClick={() => runCopy(id)}>复制订单</CopyButton>}
                    {!enableEdit && platform === PlatformType.Admin &&
                        <CopyFullButton type={'link'} loading={loadingCopyFull}
                                        onClick={() => runCopyFull(id)}>整单复制</CopyFullButton>}
                    {platform === PlatformType.Admin && !enableEdit && record.status == SalesOrderStatusEnum.OVERDUE_PENDING &&
                        <OverDueButton type={'link'} loading={loadingOverDue}
                                       onClick={() => runOverDue(id)}>重算信用</OverDueButton>}
                    <OAFragment>
                        {platform === PlatformType.Admin && !enableEdit && (record.status == SalesOrderStatusEnum.OVERDUE_PENDING || record.status == SalesOrderStatusEnum.PAYMENT_PENDING) &&
                            <Button type={"link"}
                                    onClick={() => sendOAModalVisible(true, {orderId: id})}>OA送审</Button>
                            //     :
                            //     record.status == SalesOrderStatusEnum.PAYMENT_PENDING ?
                            //         <Popconfirm title={'确认OA送审'} onConfirm={() => {
                            //             doOASend({orderId: id})
                            //         }}><Button loading={oASendLoading} type={"link"}>OA送审</Button></Popconfirm> : null
                        }
                    </OAFragment>
                    {platform === PlatformType.Admin && record.status == SalesOrderStatusEnum.OVERDUE_PENDING && (
                        <OACompletePopconfirm title={'是否确认终审'}
                                              onConfirm={() => doOAComplete({orderId: record.id})}>
                            <Button type={'link'} loading={oACompleteLoading}>终审通过</Button>
                        </OACompletePopconfirm>
                    )}
                    {platform === PlatformType.Admin && !enableEdit && record.status == SalesOrderStatusEnum.PAYMENT_PENDING &&
                        <ErpSyncFragment><Button type={"link"} loading={erpSyncLoading}
                                                 onClick={() => doErpSync(id)}>ERP同步</Button></ErpSyncFragment>}
                    {platform === PlatformType.Admin && !enableEdit && record.status != SalesOrderStatusEnum.PART_DELIVERY && record.status != SalesOrderStatusEnum.DELIVERED && record.status != SalesOrderStatusEnum.RECEIVED &&
                        <ClosePopconfirm title={'是否确认关闭'} onConfirm={() => runCloseOrder(id)}><Button
                            loading={loadingClose} type={'link'}>关闭</Button></ClosePopconfirm>}
                    {(!enableEdit && platform === PlatformType.Admin) &&
                        <Button type={'link'} onClick={() => LogModal.open(LogType.SalesOrder, id)}>日志</Button>}
                    {!enableEdit && <PrintButton type={'link'}
                                                 onClick={() => window.open(`/sales/order/print/${id}`)}>打印</PrintButton>}
                    <Button type={'link'}
                            onClick={() => enableEdit ? setEnableEdit(false) : history.goBack()}>返回</Button>
                </Divider>
            </Space>
        </div>
        <AntDivider/>
        <div>
            <h3 className={styles.SectionTitle}>基本信息</h3>
            <Form form={form} labelCol={{span: 8}} disabled={true}>
                <Form.Item name={'id'} noStyle/>
                <Row gutter={12}>
                    <Col span={8}>
                        <Form.Item name={'code'} label={'订单编号'} required={true}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'orderDate'} label={'订单日期'}>
                            <DatePicker style={{width: '100%'}}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'dealerName'} label={'客户'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'hospitalFullName'} label={'终端医院全称'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'expressId'} label={'运输方式'}>
                            <BaseDataSelect name={'expresses'}/>
                            {/*<Input/>*/}
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'orderType'} label={'订单类型'}>
                            {/*<Select url={''} getData={data => data?.data || []} textField={'name'} valueField={'id'}/>*/}
                            <BaseDataSelect name={'orderTypes'} appendNull={false}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'expectDeliveryTime'} label={'期望交期'}>
                            <DatePicker style={{width: '100%'}} disabled={!enableEdit}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'salesManName'} label={'销售人员'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'businessManName'} label={'商务人员'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'province'} label={'省'}>
                            <AreaSelect/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'city'} label={'市'}>
                            <AreaSelect type={'city'}
                                        parent={province}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'detailAddress'} label={'详细地址'}>
                            <Input addonAfter={enableEdit &&
                                <a onClick={() => setDealerShippingModalVisible(true)}>选取</a>}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'receiver'} label={'收货人'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'receiverPhone'} label={'收货人电话'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'paymentForm'} label={'付款形式'}>
                            <DictSelect dict={'PaymentForm'} appendNull={false}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'currencyName'} label={'币种'}>
                            {/*<Select url={''} getData={data => data?.data || []} textField={'name'} valueField={'id'}/>*/}
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'invoiceType'} label={'发票类型'}>
                            <DictSelect dict={'InvoiceType'} appendNull={false}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'period'} label={'账期'}>
                            <InputNumber addonAfter={'天'} step={1} style={{width: '100%'}}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'giveawayInvoiced'} label={'赠品是否开票'} valuePropName={'checked'}>
                            <Switch/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'invoiceAddress'} label={'发票详细地址'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <TemporaryPeriodCol span={8}>
                        <Form.Item name={'temporaryPeriod'} label={'临时账期'}>
                            <InputNumber addonAfter={'天'} step={1} style={{width: '100%'}}/>
                        </Form.Item>
                    </TemporaryPeriodCol>
                    <Col span={8}>
                        <Form.Item name={'rebates'} label={'订单返利'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'orderSource'} label={'订单来源'}>
                            <AntSelect options={SalesOrderSourceOptions} fieldNames={{value: 'value', label: 'text'}}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'sourceOrderNumber'} label={'来源单号'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'invoiceDate'} label={'开票日期'}>
                            <DatePicker style={{width: '100%'}}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'invoices'} labelCol={{span: 4}} label={'发票号'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'associateNum'} label={'关联单号'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    {platform == PlatformType.Admin && <Col span={8}>
                        <Form.Item name={'specialInvoice'} label={'特殊开票'} valuePropName={'checked'}>
                            <Switch/>
                        </Form.Item>
                    </Col>}
                    {platform == PlatformType.Admin && <Col span={8}>
                        <Form.Item name={'thermometer'} label={'温度计'} valuePropName={'checked'}>
                            <Switch disabled={!enableEdit}/>
                        </Form.Item>
                    </Col>}
                    {platform == PlatformType.Admin && <Col span={8}>
                        <Form.Item name={'coldChain'} label={'冷链'} valuePropName={'checked'}>
                            <Switch disabled={!enableEdit}/>
                        </Form.Item>
                    </Col>}
                    <Col span={24}>
                        <Form.Item name={'remark'} label={'备注'} labelCol={{span: 2}}>
                            <Input.TextArea rows={3} disabled={!enableEdit}/>
                        </Form.Item>
                    </Col>
                </Row>
                <div>
                    <h3 className={styles.SectionTitle}>商品信息</h3>
                </div>
                <Form.List name={'item'}>
                    {(fields, operation, meta) => (
                        <Table className={styles.ProductTable} columns={productColumns}
                               sticky
                               dataSource={products.length ? form.getFieldValue('item') : (enableEdit ? [{}] : [])}
                               pagination={false} scroll={{x: '100%'}}/>
                    )}
                </Form.List>
                <div className={styles.ProductSummary}>
                    <br/>
                    <table>
                        <tr>
                            <td>商品总额：</td>
                            <td>{renderSummaryAmount()}</td>
                        </tr>
                        <tr>
                            <td>预估运费：</td>
                            <td>{renderExpectShippingCost()}</td>
                        </tr>
                        <tr>
                            <td>运费：</td>
                            <td>{renderShippingCost()}</td>
                        </tr>
                        <tr style={{fontSize: 'large'}}>
                            <td>订单合计：</td>
                            <td style={{color: 'var(--danger-color)'}}>{renderAmount()}</td>
                        </tr>
                    </table>
                </div>
            </Form>
            {productSelectedModalVisible &&
                <ProductSelectModal url={productApi.getProductsByOrder} queryParams={{orderId: id}} multiple={true}
                                    open={productSelectedModalVisible}
                                    onCancel={() => setProductSelectedModalVisible(false)}
                                    onComplete={doAddProduct}/>}
            {dealerShippingModalVisible && <DealerShippingSelectModal onComplete={doSelectAddress}
                                                                      multiple={false}
                                                                      open={dealerShippingModalVisible}
                                                                      onCancel={() => setDealerShippingModalVisible(false)}
                                                                      queryParams={{dealerId: record.dealerId}}
            />}
            <SendOAPeriodModal {...sendOAModalProps} orderId={id}/>

            <RemarkModal open={remarkModalVisible} title={'备注'} onCancel={() => setRemarkModalVisible(false)}
                         onComplete={(remark: string) => finishRemark(remark)}/>

            {contractSelectModalVisible && record.dealerId && <ContractSelectModal onComplete={handleContractSelected}
                                                                                   confirmLoading={loadingUpdateContract}
                                                                                   multiple={false}
                                                                                   open={contractSelectModalVisible}
                                                                                   url={contractApi.getContractsDict}
                                                                                   queryParams={{dealerId: record.dealerId}}
                                                                                   onCancel={() => setContractSelectModalVisible(false)}
            />}


        </div>
    </div>
}

export default DetailTab;
